/**
 * NA-408 "Show Block IDs": builds the learner-facing block identifier string.
 * Format: C<courseId>.L<lessonId>.B<blockId>.<LOCALE>[.MT|.HT], uppercased.
 * `courseId` is omitted entirely (not placeholdered) when there is no course
 * context, e.g. a lesson opened in the standalone Lesson Editor preview.
 */
export interface FormatBlockIdInput {
  courseId?: string | number | null;
  lessonId: string | number;
  blockId: string | number;
  /** Locale of the text actually rendered for this block, not the learner's selected UI locale. */
  locale: string;
  translationType?: 'mt' | 'ht' | null;
}

export function formatBlockId({
  courseId,
  lessonId,
  blockId,
  locale,
  translationType,
}: FormatBlockIdInput): string {
  const segments = [
    courseId != null ? `C${courseId}` : null,
    `L${lessonId}`,
    `B${blockId}`,
    locale,
    translationType ? translationType : null,
  ].filter((segment): segment is string => segment != null && segment !== '');
  return segments.join('.').toUpperCase();
}
